<script lang="ts">
    import Content from '../../_common/content.svelte'

    import { onDestroy, onMount } from 'svelte'
    import dayjs from 'dayjs'
    import weekOfYear from 'dayjs/plugin/weekOfYear'
    dayjs.extend(weekOfYear)
    import type { Goalboard } from '../../../modules/toolsApi/goalboards/goalboard.entity'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { isFullscreen } from '../../_common/stores'
    import type { User } from '../../../modules/usersApi/users/user'
    import type { GoalboardDataDto } from './goalboard-member.dto'
    import GoalboardMembersBox from './goalboard-members-box.svelte'
    import { KPIIndicators, KPI_OLD_BUYER_LOOKBACK_MONTHS } from '../../../modules/use-cases/kpi-indicators'
    import Zact from '../../_common/z/zact.svelte'

    let fullscreen = false
    isFullscreen.subscribe((value) => {
        fullscreen = value
    })

    export let form = false
    export let allFromLoggedUser = false

    let selectedGoalId: string = null
    let goals: Goalboard[] = []
    let members: GoalboardDataDto[] = []
    let show = false
    let selectedDate = null
    let convertedPartial: Date = null
    let goalWindowDays: number = 0

    async function loadGoals() {
        goals = await window.api.tools.goalboards.getAll()
    }

    onMount(async () => {
        await loadGoals()
        if (goals.length > 0) {
            selectedGoalId = goals[0].goalboardId
            await onChangeGoal()
        }
    })

    async function onChangeGoal() {
        let goal = goals.find((el) => el.goalboardId === selectedGoalId)
        if (!goal) return
        selectedDate = getHTMLCurrentDate(goal.goalWindowDays, new Date())
        console.log('sd', selectedDate, goal.goalWindowDays)
        await loadMembers()
    }

    function getHTMLCurrentDate(days: number, date: Date) {
        if (days === 30) return dayjs(new Date()).format('YYYY-MM')
        if (days === 15) return dayjs(new Date()).format('YYYY-MM-DD')
        if (days === 1) return dayjs(new Date()).format('YYYY-MM-DD')
        const stringDate = date.getFullYear() + '-W' + dayjs(date).week()
        return stringDate
    }

    function getDatesFromDateString(goalWindowDays: number, selectedDate: string): { from: Date; to: Date } {
        let _selectedDate = null
        if (selectedDate.includes('-W')) {
            const tempDate = new Date(parseInt(selectedDate.split('-')[0]), 0, 1)
            tempDate.setDate(parseInt(selectedDate.split('-W')[1]) * 7 - 7)
            _selectedDate = new Date(tempDate)
        } else if (selectedDate.split('-').length === 2) {
            _selectedDate = new Date(selectedDate + '-05')
        } else {
            _selectedDate = new Date(selectedDate)
        }
        let from: Date = null
        let to: Date = null
        // se diário
        if (goalWindowDays === 1) {
            from = new Date(_selectedDate)
            to = new Date(from)
            to.setDate(to.getDate() + 1)
        }
        if (goalWindowDays === 7) {
            from = new Date(_selectedDate)
            from.setDate(from.getDate() - from.getDay())
            to = new Date(from)
            to.setDate(to.getDate() + 6)
        }
        // quinzenal
        if (goalWindowDays === 15) {
            from = new Date(_selectedDate)
            if (from.getDate() <= 14) {
                to = new Date(from)
                from.setDate(0)
                to.setDate(14)
            } else {
                from.setDate(14)
                to = new Date(from.getFullYear(), from.getMonth() + 1, 0)
            }
        }
        // mensal
        if (goalWindowDays === 30) {
            from = new Date(_selectedDate)
            to = new Date(from.getFullYear(), from.getMonth() + 1, 0)
            from.setDate(0) // como há ajuste de fuso, então vamos para o último dia do mês anterior.
        }
        from.setMinutes(from.getMinutes() + from.getTimezoneOffset())
        from.setHours(0, 0, 0, 0)
        to.setHours(23, 59, 59, 999)
        console.log('dates', { from, to })
        return { from, to }
    }

    let timeoutHandle
    async function loadMembers() {
        members = []
        if (!selectedGoalId) return
        if (!fullscreen) show = true
        let goalRefreshTime = 0
        let users: User[] = await window.api.users.companies.getCompanyUsers()
        if (allFromLoggedUser) {
            users = users.filter((el) => el.userId === window.store.token.userId)
        }
        for (const goal of goals) {
            if (!allFromLoggedUser && goal.goalboardId !== selectedGoalId) continue
            if (allFromLoggedUser && !goal.showIcon) continue // não exibir se está desativado o ícone na barra de menu.
            if (allFromLoggedUser) selectedDate = getHTMLCurrentDate(goal.goalWindowDays, new Date())
            goalWindowDays = goal.goalWindowDays
            if (goalRefreshTime === 0 || goalRefreshTime > goal.refreshTime) goalRefreshTime = goal.refreshTime
            let { from, to } = getDatesFromDateString(goal.goalWindowDays, selectedDate)

            if (!goal.users || goal.users.length === 0) goal.users = [...users.map((el) => el.userId)]
            for (const user of users) {
                // se foram filtrados alguns usuários então só gera um member se for esse usuário
                if (goal.users?.length > 0 && !goal.users.some((el) => el === user.userId)) continue
                members.push({
                    goal: goal,
                    dates: { from, to },
                    member: {
                        contacted: 0,
                        connected: 0,
                        convertedByMe: 0,
                        convertedFromMine: 0,
                        scheduled: 0,
                        showToMe: 0,
                        showFromMine: 0,
                        showFromMinePercentual: 0,
                        convertedByMePercentual: 0,
                        convertedFromMinePercentual: 0,
                        userId: user.userId,
                        user: user,
                    },
                })
            }

            // calcula a data limite de acompanhamento de conversão
            const toWindow = new Date(to)
            toWindow.setDate(toWindow.getDate() + goal.conversionWindowDays)
            convertedPartial = dayjs(toWindow).diff(new Date(), 'day') > 0 ? new Date(toWindow) : null

            let kpiIndicators: KPIIndicators = new KPIIndicators()
            console.log('meta_dates', { selectedDate, from, to })
            const buyersFrom = new Date(from)
            buyersFrom.setMonth(buyersFrom.getMonth() - KPI_OLD_BUYER_LOOKBACK_MONTHS)
            await kpiIndicators.loadBuyersSource(buyersFrom, from)
            await kpiIndicators.refreshData(from, to)
            for (const member of members) {
                const com = await kpiIndicators.getCommunication(member.member.userId)
                const schedCreated = await kpiIndicators.getSchedulesByCreationDate(member.member.userId)
                const schedAp = await kpiIndicators.getSchedulesByAppointmentDate(member.member.userId)
                const conv = await kpiIndicators.getConversions(
                    goal.conversionWindowDays,
                    member.member.userId,
                    schedAp.showToMe,
                    schedAp.showFromMine,
                    'consultingsAt',
                )
                console.log('member -------', member.member.user?.userName)
                console.log('com', com)
                console.log('schedCreated', schedCreated)
                console.log('schedAp', schedAp)
                console.log('conv', conv)
                member.member.connected = com.connected
                member.member.contacted = com.contacted

                member.member.scheduled = schedCreated.scheduled
                member.member.showFromMinePercentual = schedAp.showFromMinePercentual

                member.member.showFromMine = schedAp.showFromMine
                member.member.showToMe = schedAp.showToMe

                member.member.convertedByMe = conv.convertedByMe
                member.member.convertedByMePercentual = conv.convertedByMePercentual
                member.member.convertedFromMine = conv.convertedFromMine
                member.member.convertedFromMinePercentual = conv.convertedFromMinePercentual
            }
        }
        members = members
        show = false
        evaluateRefresh(goalRefreshTime)
    }

    function evaluateRefresh(goalRefreshTime: number) {
        if (timeoutHandle) clearTimeout(timeoutHandle)
        if (goalRefreshTime > 0) {
            let refreshTime = goalRefreshTime * 1000 * 60
            timeoutHandle = setTimeout(async () => await loadMembers, refreshTime)
        }
    }

    onDestroy(() => {
        if (timeoutHandle) clearTimeout(timeoutHandle)
    })
</script>

<Content footer={true}>
    {#if !form}
        <Zact>
            <div class="date input-group fix-width">
                <label for="" class="input-group-text">Meta</label>
                <select class="form-select" bind:value={selectedGoalId} on:change={onChangeGoal}>
                    {#each goals as goal}
                        <option value={goal.goalboardId}>{goal.label}</option>
                    {/each}
                </select>
            </div>

            <div class="input-group fix-width">
                <label for="" class="input-group-text">Data</label>
                {#if goalWindowDays === 30}
                    <input type="month" bind:value={selectedDate} on:change={() => loadMembers()} class="form-control form-control-sm frame_date" />
                {:else if goalWindowDays === 7}
                    <input type="week" bind:value={selectedDate} on:change={() => loadMembers()} class="form-control form-control-sm frame_date" />
                {:else}
                    <input type="date" bind:value={selectedDate} on:change={() => loadMembers()} class="form-control form-control-sm frame_date" />
                {/if}
            </div>
            <div class="spacer h-mobile" />
        </Zact>
    {/if}
    <div class="members_box">
        {#each members as data}
            <GoalboardMembersBox showName={!allFromLoggedUser} {data}></GoalboardMembersBox>
        {/each}
    </div>
</Content>
<LoadSpinner delay={0} {show} />

<style>
    .fix-width {
        max-width: 280px;
    }

    .members_box {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
        gap: 16px;
        margin-top: 16px;
    }
</style>
